import { render, staticRenderFns } from "./LoginH5.vue?vue&type=template&id=2f695b0c&scoped=true"
import script from "./LoginH5.vue?vue&type=script&lang=js"
export * from "./LoginH5.vue?vue&type=script&lang=js"
import style0 from "./LoginH5.vue?vue&type=style&index=0&id=2f695b0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f695b0c",
  null
  
)

export default component.exports